import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Card, CardPrimaryAction, Button, Typography, Icon } from 'rmwc';
import { LoadingBar } from '../../components/util/LoadingBar';
import { ScoreSideBySide } from '../../components/Onboarding/ScoreVariants';
import { Subscores } from '../../components/charts/Subscores';
import { LegalNotices } from '../../components/LegalNotices';
import { Money } from '../../components/Money';

import { runFullSimulation } from '../../actions/simulationActions';
import { fetchSpendingPlan } from '../../actions/wealthManagementActions';
import { trackEvent } from '../../actions/trackEventActions';
import { Text } from '../../components/Text';
import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';
import { isTest } from '../../helpers/environment';
import { ExpandableGroup, ExpandableItem } from '../../components/Expandable';
import { PlanImpactSecondary } from '../../components/charts/PlanImpact';

import { scoreCardCopy } from '../../components/charts/scoreConstants';
import { wlPath, wlVar } from '../../helpers/whitelabel';
import { newWindow } from '../../helpers/newWindow';
import { fetchContentPages } from '../../actions/contentPagesActions';

import { kebabToCamelCase } from '../../helpers/stringHelper';
import { media, Container } from '../../helpers/styleConstants';

const CircularButtonRightCaret = styled.div`
  height: 40px;
  width: 40px;
  background: #4a90e2;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const ScoreMeaning = ({ title, initialValue, updateValue, format, subtitle, explanation }) => (
  <div className="mb-4" style={{ display: 'flex' }}>
    <div style={{ width: '125px' }}>
      <PlanImpactSecondary title={title} initialValue={initialValue} updateValue={updateValue} format={format} />
    </div>
    <div style={{ marginLeft: '32px' }}>
      <Typography tag="div" use="headline5" className="mb-2">
        {title}
      </Typography>
      <Typography tag="div" use="body1" className="mb-2">
        {subtitle}
      </Typography>
      <Typography style={{ position: 'relative' }} tag="div" use="body1" theme="text-secondary-on-background">
        <div style={{ position: 'absolute', width: '30px', left: '-30px', top: '0', textAlign: 'right' }}>
          <Icon style={{ fontSize: '18px', padding: '1px 5px 0 0', color: '#F2C94C' }}>info</Icon>
        </div>
        {explanation}
      </Typography>
    </div>
  </div>
);

export class ScoreIntro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandableOpen: -1,
    };
    this.moredetails = null;
    this.howScore = null;
    if (!this.props.contentPages) {
      this.props.fetchContentPages();
    }
  }
  componentDidMount() {
    if (!this.props.results) {
      this.props.runFullSimulation();
    }
    if (!this.props.spendingPlan) {
      this.props.fetchSpendingPlan();
    }
  }

  toHowScore = () => {
    window.scrollTo({
      top: ReactDOM.findDOMNode(this.howScore).getBoundingClientRect().top,
      behavior: 'smooth',
    });
  };

  dialogToAssumptions() {
    this.setState({ expandableOpen: 0 }, () => {
      console.log('MD', ReactDOM.findDOMNode(this.moredetails).getBoundingClientRect().top);
      window.scrollTo({
        top: ReactDOM.findDOMNode(this.moredetails).getBoundingClientRect().top,
        behavior: 'smooth',
      });
    });
  }

  render() {
    const {
      dashboard,
      people,
      results,
      spendingPlan,
      onFinish,
      openRegistrationDialog,
      openEmailDialog,
      history,
      contentPages,
    } = this.props;
    const { expandableOpen } = this.state;

    const moneyLastsUntilAge = year => people[0].age + (year - new Date().getFullYear());

    if (!results || !spendingPlan || !contentPages) {
      return <LoadingBar />;
    }

    const totalGained = contentPages.reduce((acc, item) => acc + item.gain, 0);

    return (
      <Fragment>
        <div style={{ paddingBottom: '70px', background: 'linear-gradient(#FAFAFA, rgba(163, 219, 255, 0.3))' }}>
          <Container>
            <div style={{ padding: '0 15px 0 15px', maxWidth: '800px', margin: 'auto' }}>
              <ScoreSideBySide
                results={results}
                moneyLastsUntilAge={moneyLastsUntilAge}
                onContinue={onFinish}
                benchmarkLeft={spendingPlan.retirement_budget * 12}
                totalGain={totalGained}
              />
            </div>
          </Container>
        </div>

        <Container>
          <div style={{ width: '95%', maxWidth: '575px', margin: '-40px auto 0', position: 'relative' }}>
            <img src={require('images/lightbulb.png')} style={{ position: 'absolute', top: '-50px', left: '-50px' }} />
            <Card style={{ position: 'relative', borderRadius: '8px' }} onClick={onFinish}>
              <CardPrimaryAction>
                <div
                  style={{
                    padding: '1rem 1rem 1rem 1.5rem',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography use="body1" theme="text-primary-on-background">
                      <strong>We have some ideas on how to improve your financial health</strong>
                    </Typography>
                    <Typography use="body1" theme="text-secondary-on-background">
                      {'Explore 16 planning ideas with '}
                      <Typography use="body1" theme="secondary">
                        <strong>
                          +<Money amount={totalGained} round={-3} />
                        </strong>
                      </Typography>
                      {` of potential value`}
                    </Typography>
                  </div>
                  <div
                    style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', marginLeft: '1rem' }}
                  >
                    <CircularButtonRightCaret>
                      <Icon>keyboard_arrow_right</Icon>
                    </CircularButtonRightCaret>
                  </div>
                </div>
              </CardPrimaryAction>
            </Card>
            <div
              className="mt-2 d-none"
              style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              onClick={this.toHowScore}
            >
              <Icon style={{ paddingRight: '10px' }} theme="text-primary-on-background">
                help_outline
              </Icon>
              <a href="#">How did you get this score?</a>
            </div>
          </div>
        </Container>

        <div className="pb-4" style={{ background: '#fbfbfb' }}>
          <Container>
            <div style={{ padding: '0 15px 0 15px', maxWidth: '800px', margin: 'auto' }}>
              <Subscores scores={results.scores} ref={node => (this.howScore = node)} />
            </div>
          </Container>
        </div>
        <div className="pt-3 pb-4" style={{ background: 'linear-gradient(rgba(163, 219, 255, 0.3), #FAFAFA)' }}>
          <Container>
            <div style={{ padding: '0 15px 0 15px', maxWidth: '800px', margin: 'auto' }}>
              <Typography tag="div" use="headline5" className="mt-3 mb-0">
                <strong>About Planning Discovery</strong>
              </Typography>
              <Typography tag="div" use="headline6" className="mb-3" theme="text-secondary-on-background">
                from {wlVar('brand_name')}
              </Typography>
              <Typography tag="div" use="body1" className="mb-2">
                Based on your answers, we analyzed 25 areas of your finances to identify where a good action plan could
                make the biggest impact.
              </Typography>
              <Typography tag="div" use="body1" className="mb-3">
                Our Planning Discovery tool is just a starting point, but it gives you an idea of the benefit that
                thoughtful planning can have. We hope you find it helpful!
              </Typography>
              <div>
                <Button onClick={onFinish} theme="secondary-bg on-secondary">
                  Explore Planning Ideas
                </Button>
                <Button
                  onClick={() => newWindow(wlVar('link_href_services'), 'ScoreIntro')}
                  theme="secondary"
                  style={{ marginLeft: 8 }}
                >
                  {wlVar('link_label_services') || 'About Our Services'}
                </Button>
              </div>
            </div>
          </Container>
        </div>
        <hr className="mt-5 mb-2 hrbr-rule" />                
        <Container>
          {wlVar('disclosure') && (
            <div style={{ padding: '0 15px 0 15px', maxWidth: '800px', margin: 'auto' }}>
              <Typography tag="div" use="headline5" className="mt-3 mb-3">
                <strong>Disclosure</strong>
              </Typography>              
              <Typography
                tag="div"
                className="mb-2"
                use="caption"
                dangerouslySetInnerHTML={{ __html: wlVar('disclosure') }}
              />
            </div>
          )}

          <div style={{ padding: '0 15px 0 15px', maxWidth: '800px', margin: 'auto' }}>
            <Typography tag="div" use="headline5" className="mt-3 mb-3">
              <strong>Disclaimer</strong>
            </Typography>
            <Typography tag="div" className="mb-2" use="caption">
              Improvement potential is based on the methodology described herein and is based on the information provided by the user. Actual results are not guaranteed and may vary over time.
            </Typography>

            <Typography tag="div" className="mb-2" use="caption" dangerouslySetInnerHTML={{ __html: wlVar('disclaimer') }} />
            <LegalNotices />
          </div>
        </Container>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    dashboard: state.modules.dashboard.data,
    people: state.people.data,
    results: state.simulations.results,
    spendingPlan: state.modules.spendingPlan.data,
    contentPages: state.contentPages.data,
    state: state,
  };
}

export default withEmailDialog(
  withRegistrationDialog(
    connect(mapStateToProps, { fetchSpendingPlan, runFullSimulation, fetchContentPages, trackEvent })(ScoreIntro)
  )
);
